import {filters as flightFilters} from '~src/utils/flights/flights-blank-states.src'
import {filters as hotelFilters} from '@/utils/hotels/hotels-blank-states'
import {addDays, format} from 'date-fns'

export const searchRequest = () => ({
        convertToCurrency: null,
        departureCityId: null,
        arrivalCityId: null,
        startDate: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
        endDate: format(addDays(new Date(), 2), 'yyyy-MM-dd'),
        adults: 1,
        childrenAges: [],
    }),
    searchResponse = () => ({
        filters: {
            flights: flightFilters(),
            hotels: hotelFilters(),
        },
        offers: {
            hotelsCount: 0,
            flightsCount: 0,
        },
        selectedOffersInfo: [],
        clientPrice: {
            price: {
                amount: 0,
            },
        },
    })
